import { render, staticRenderFns } from "./InstanceLabels.vue?vue&type=template&id=5406440d&scoped=true"
import script from "./InstanceLabels.vue?vue&type=script&lang=js"
export * from "./InstanceLabels.vue?vue&type=script&lang=js"
import style0 from "./InstanceLabels.vue?vue&type=style&index=0&id=5406440d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406440d",
  null
  
)

export default component.exports